import React from "react";

import Navbar3 from "../Components/Navbar3";
import BasketballProgramGrid from "../Components/BasketballProgramGrid";
import basketballPrograms from "../data/BasketballPrograms";
import BasketballEvent from "../Components/BasketballEvent";
import TextDivider from "../Components/TextDivider";
import Footer from "../Components/Footer";

function Basketball() {
  return (
    <>
      <Navbar3 />
      <div className='event-experience-image'>
        <img src='/s3/ads-basketball-banner.jpg' alt='ADS Volleyball' />
      </div>
      <section className="camp-section">
        <div className="container">
          <div className="row">
                  <div className="col-12 text-center">
                      <h2 className="camp-section__title futuraPTMedium">
                        CAMPS & CLINICS
                      </h2>
                  </div>
              </div>
        </div>
        <BasketballProgramGrid programs={basketballPrograms} />
      </section>
      <BasketballEvent />
      <TextDivider />
      <Footer />
    </>
  );
}

export default Basketball;